import {
    formatPermissions,
    can as helpCan,
} from '../../../services/auth/permissions'

/**
 * @description
 * Check if user is authenticated with state data (from local storage)
 *
 * @param {@object} state with state data of auth module
 * @return {boolean} true is authenticated, false otherwise
 */
const isAuthenticated = state => !!state.token

const userOfficeID = state => {
    if (!state.user || !state.user.hr_employee) return
    return state.user.hr_employee.g_branch_office_id
}

/**
 * @description
 * Get status of user (success, error or loading)
 *
 * @param {object} state with state data of auth module
 * @return {string}
 */
const authStatus = state => state.status

const branchOfficeID = state =>
    state.user ? state.user.hr_employee.g_branch_office_id : null

const can = state => helpCan(formatPermissions(state.permissions))

const branchOfficeName = state =>
    state.user &&
    state.user.hr_employee &&
    state.user.hr_employee.g_branch_office
        ? state.user.hr_employee.g_branch_office.name
        : ''

export default {
    isAuthenticated,
    authStatus,
    userOfficeID,
    branchOfficeID,
    branchOfficeName,
    can,
}
